import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div
                className="min-h-screen flex items-center justify-center"
                data-testid="auth-loading"
            >
                <div className="font-display text-2xl animate-pulse">
                    LOADING…
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (requireAdmin && !user.is_admin) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
